<template>
  <div class="mt-sm-4">
    <component
      :user_id="user_id"
      :is="state"
      :currentRequest="currentRequest"
      :data="data"
      v-model="setValue"
    />
  </div>
</template>
<script>
export default {
  methods: {},
  components: {
    new: () => import("./new"),
    sent: () => import("./sent"),
    cancel: () => import("./cancel"),
    confirm: () => import("./confirm"),
  },
  methods: {},
  data: () => ({}),
  props: ["value", "data", "user_id"],
  computed: {
    requests() {
      return this.data.service_requests.filter(
        (item) => item && item.service && item.service.code === "apex"
      );
    },
    currentRequest() {
      try {
        return this.requests[0];
      } catch (error) {}

      return null;
    },
    state() {
      return this.currentRequest && this.currentRequest["state"]
        ? this.currentRequest["state"]
        : "cancel";
    },
    setValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style>
</style>
 